import { defineMessages } from 'react-intl';

export default defineMessages({
    
    offerOfInsuranceBottomMessage: {
        id: 'ent.offerdetails.offerofinsurance.Will Be Returned',
        defaultMessage: '*Payments received after this offer expires will be returned to you, and no policy will be issued.'
    },
    offerOfInsuranceExpirationDateLabe: {
        id: 'ent.offerdetails.offerofinsurance.Offer Expiration Date',
        defaultMessage: 'Offer Expiration Date:'
    },
});
